import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Expense } from '@cl/shared/models/expenses/expense.model';
import { NzImageService } from 'ng-zorro-antd/image';
import { BaseDownloadServiceWithFilter } from './base.service';
import { lastValueFrom } from 'rxjs';
import { CommandResult } from '@cl/shared/models';
import { FileMetadata } from '@cl/shared/models/file.model';
import { ExpenseFilter } from '@cl/shared/models/expenses/expense-filter.model';
import { ExpenseCreatorExpenseNotification } from '@cl/shared/models/expenses/expense-creator-expense-notification';
import { BookkeeperExpenseNotification } from '@cl/shared/models/expenses/bookkeeper-expense-notification.model';

@Injectable({ providedIn: 'root' })
export class ExpensesService extends BaseDownloadServiceWithFilter<Expense, ExpenseFilter> {
    loadingChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        httpClient: HttpClient,
        protected nzImageService: NzImageService,
    ) {
        super(httpClient, '/api/v1/expenses/', nzImageService);
    }

    async addExpenseFile(expenseFileFormData: FormData): Promise<void> {
        return await lastValueFrom(this.httpClient.post<void>(`${this.baseApiUrl}expense-file`, expenseFileFormData));
    }

    async downloadExpenseFile(downloadExpenseFileParams: HttpParams): Promise<void> {
        return this.handleFileDownloading(
            lastValueFrom(this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}download-file`, { params: downloadExpenseFileParams })),
        );
    }

    async getExpenseFileMetadata(expenseId: number, expenseFileId: number): Promise<CommandResult<FileMetadata>> {
        const params = new HttpParams().append('expenseId', expenseId).append('expenseFileId', expenseFileId);

        return await lastValueFrom(this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}download-file`, { params }));
    }

    async deleteExpenseFile(expenseId: number, expenseFileId: number): Promise<void> {
        return await lastValueFrom(this.httpClient.delete<void>(`${this.baseApiUrl}expense-file/${expenseId}/${expenseFileId}`));
    }

    async sendExpenseCreatorExpenseNotification(notificationOptions: ExpenseCreatorExpenseNotification): Promise<CommandResult<void>> {
        return await lastValueFrom(this.httpClient.post<CommandResult<void>>(`${this.baseApiUrl}expense-creator-notification`, notificationOptions));
    }

    async sendBookkeeperExpenseNotification(notificationOptions: BookkeeperExpenseNotification): Promise<CommandResult<void>> {
        return await lastValueFrom(this.httpClient.post<CommandResult<void>>(`${this.baseApiUrl}bookkeeper-notification`, notificationOptions));
    }
}
